import { render } from "./AdOrderRequestsPage.vue?vue&type=template&id=4ed6631a&scoped=true"
import script from "./AdOrderRequestsPage.vue?vue&type=script&lang=js"
export * from "./AdOrderRequestsPage.vue?vue&type=script&lang=js"

import "./AdOrderRequestsPage.vue?vue&type=style&index=0&id=4ed6631a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/colordemy-customers/colordemy-customers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed6631a"]])

export default __exports__